"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Chart = require("../../Chart");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var calculateLayout = function calculateLayout(props) {
  var colors = props.colors,
    data = props.data,
    height = props.height,
    isCategorical = props.isCategorical,
    isTimeSeries = props.isTimeSeries,
    series = props.series,
    width = props.width,
    xAxis = props.xAxis;
  var _CalculateLayout$cart = _Chart.CalculateLayout.cartesianLayout({
      data: data,
      height: height,
      isAxisInverted: false,
      isCategorical: isCategorical,
      isTimeSeries: isTimeSeries,
      width: width,
      xAxis: xAxis
    }),
    padding = _CalculateLayout$cart.padding,
    xAxisLayout = _CalculateLayout$cart.xAxisLayout,
    yAxisLayout = _CalculateLayout$cart.yAxisLayout;
  var plotHeight = height - padding.top - padding.bottom;
  var plotWidth = width - padding.left - padding.right;
  var displaySeries = series.map(function (s, index) {
    return _objectSpread(_objectSpread({}, s), {}, {
      color: s.color || colors[index % colors.length]
    });
  });
  var result = _objectSpread(_objectSpread({}, props), {}, {
    padding: padding,
    plotHeight: plotHeight,
    plotWidth: plotWidth,
    series: displaySeries,
    xAxisLayout: xAxisLayout,
    yAxisLayout: yAxisLayout
  });
  return result;
};
var _default = exports["default"] = calculateLayout;
//# sourceMappingURL=calculateLayout.js.map